<template>
    <div>
        <buttonlist @help="help" @add="add" @search="search" @reflash="reflash" @exps="exps" @save="save" @del="del" @imp="imp"
                    ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <el-tabs :tab-position="'top'" type="" @tab-click="selectInfo">
                    <el-tab-pane :label="$t('getapi[945]')" name="0">
                        <div>
                            <el-button type="primary" size="mini" @click="getPro" :disabled="!btn.Pro">{{$t('getapi[7045]')}}</el-button>
                        </div>
                        <el-table
                                id="xpane-0"
                                :data="dataSet"
                                ref="singleTable"
                                v-loading="loading"
                                :highlight-current-row="true"
                                show-overflow-tooltip="true"
                                queryData="ProSRMasterViewInfo"
                                :filter_language="['Relation_MPS_Line_ID','SR_StatusName','Bom_Config_Flag']"
                                :filter_thousandth="['Plan_qty']"
                                :filter_date="['Plan_date']"
                                border
                                stripe
                                size="mini"
                                @row-click="editInfo"
                                @row-dblclick="openEdit"
                                @selection-change="handleSelectionChange"
                                :height="tableHeight - reduceTableHeight"
                                header-row-class-name="headerclass"
                                style="width: 100%; margin-top:0px"
                        >
                            <el-table-column type="selection" align="center"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="SR_code" :label="$t('getapi[3663]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="SR_TYPE_ID" :label="$t('getapi[1122]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Part_version" :label="$t('getapi[149]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Plan_qty" :label="$t('getapi[2182]')" align="right"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Part_Code" :label="$t('getapi[112]')"></el-table-column>
                            <el-table-column prop="Relation_MPS_Line_ID" :label="$t('getapi[4120]')">
                                <template scope="scope">
                                    {{scope.row.Relation_MPS_Line_ID | lanchange}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="SR_StatusName" :label="$t('getapi[552]')">
                                <template scope="scope">
                                    {{scope.row.SR_StatusName | lanchange}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="Plan_date" :label="$t('getapi[1601]')">
                                <template scope="scope">
                                    {{scope.row.Plan_date | toDate}}
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Suggest_SO_date" :label="$t('getapi[4122]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Item_Code" :label="$t('getapi[3437]')"></el-table-column>
                            <el-table-column prop="Bom_Config_Flag" :label="$t('getapi[4123]')">
                                <template scope="scope">
                                    {{scope.row.Bom_Config_Flag | lanchange}}
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Bom_Config_Sign" :label="$t('getapi[4124]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Create_Person" :label="$t('getapi[4125]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Create_Time" :label="$t('getapi[4126]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Modify_Person" :label="$t('getapi[733]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Modify_Time" :label="$t('getapi[1210]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Audit_Person" :label="$t('getapi[4043]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Audit_Time" :label="$t('getapi[4044]')"></el-table-column>
                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[1422]')" name="1">
                        <div>
                            <el-button type="primary" size="mini" @click="batchDel" :disabled="!btn.batchDel">{{$t('getapi[40]')}}</el-button>
                            <el-button type="primary" size="mini" @click="batchRelease" :disabled="!btn.batchRelease">{{$t('getapi[3056]')}}</el-button>
                            <el-button type="primary" size="mini" @click="toMaterials" :disabled="!btn.toMaterials">{{$t('getapi[7046]')}}</el-button>
                            <el-button type="primary" size="mini" @click="toCraft" :disabled="!btn.toCraft">{{$t('getapi[7047]')}}</el-button>
                            <el-button type="primary" size="mini" @click="getPro" :disabled="!btn.Pro">{{$t('getapi[7045]')}}</el-button>
                        </div>
                        <vxe-table
                                id="xpane-1"
                                :data="dataSet1"
                                ref="singleTable1"
                                v-loading="loading"
                                :highlight-current-row="true"
                                show-overflow-tooltip="true"
                                queryData="ProSRMasterViewInfo"
                                :filter_language="['Relation_MPS_Line_ID','SR_StatusName']"
                                :filter_thousandth="['Plan_qty']"
                                border
                                stripe
                                resizable
                                size="mini"
                                :height="tableHeight - reduceTableHeight"
                                @cell-click="editInfovxe"
                                @cell-dblclick="openEdit"
                                @checkbox-all="handleSelectionChange1All"
                                @checkbox-change="handleSelectionChange1"
                                @checkbox-range-end="handleSelectionChange1"
                                :checkbox-config="{highlight: true, range: true}"
                                :mouse-config="{selected:true,area: true, extension: true}"
                                header-row-class-name="headerclass"
                                style="width: 100%; margin-top:0px"
                        >
                            <vxe-table-column type="checkbox" align="center" width="60"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="SR_code" :title="$t('getapi[3663]')" width="100px"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="SR_TYPE_ID" :title="$t('getapi[1122]')" width="100px"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="Part_version" :title="$t('getapi[149]')" width="100px"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="Plan_qty" :title="$t('getapi[2182]')" align="right" width="100px"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="Part_Code" :title="$t('getapi[112]')" width="100px"></vxe-table-column>
                            <vxe-table-column field="Relation_MPS_Line_ID" :title="$t('getapi[4120]')" width="100px">
                                <template scope="scope">
                                    {{scope.row.Relation_MPS_Line_ID | lanchange}}
                                </template>
                            </vxe-table-column>
                            <vxe-table-column field="SR_StatusName" :title="$t('getapi[552]')" width="100px">
                                <template scope="scope">
                                    {{scope.row.SR_StatusName | lanchange}}
                                </template>
                            </vxe-table-column>
                            <vxe-table-column show-footer-overflow field="Plan_date" :title="$t('getapi[1601]')" width="100px"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="Suggest_SO_date" :title="$t('getapi[4122]')" width="100px"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="Item_Code" :title="$t('getapi[3437]')" width="100px"></vxe-table-column>
                            <vxe-table-column field="Bom_Config_Flag" :title="$t('getapi[4123]')" width="100px">
                                <template scope="scope">
                                    {{scope.row.Bom_Config_Flag | lanchange}}
                                </template>
                            </vxe-table-column>
                            <vxe-table-column show-footer-overflow field="Bom_Config_Sign" :title="$t('getapi[4124]')" width="100px"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="Create_Person" :title="$t('getapi[4125]')" width="100px"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="Create_Time" :title="$t('getapi[4126]')" width="100px"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="Modify_Person" :title="$t('getapi[733]')" width="100px"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="Modify_Time" :title="$t('getapi[1210]')" width="100px"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="Audit_Person" :title="$t('getapi[4043]')" width="100px"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="Audit_Time" :title="$t('getapi[4044]')" width="100px"></vxe-table-column>
                        </vxe-table>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[6095]')" name="2">
                        <div>
                            <el-button type="primary" size="mini" @click="releaseToCreate" :disabled="!btn.releaseToCreate">{{$t('getapi[7048]')}}</el-button>
                            <el-button type="primary" size="mini" @click="bulkOrder" :disabled="!btn.bulkOrder">{{$t('getapi[4478]')}}</el-button>
                            <el-button type="primary" size="mini" @click="batchCancel" :disabled="!btn.batchCancel">{{$t('getapi[6]')}}</el-button>
                            <el-button type="primary" size="mini" @click="toMaterials" :disabled="!btn.toMaterials">{{$t('getapi[7046]')}}</el-button>
                            <el-button type="primary" size="mini" @click="toCraft" :disabled="!btn.toCraft">{{$t('getapi[7047]')}}</el-button>
                            <el-button type="primary" size="mini" @click="getPro" :disabled="!btn.Pro">{{$t('getapi[7045]')}}</el-button>
                        </div>
                        <vxe-table
                                id="xpane-2"
                                :data="dataSet2"
                                ref="singleTable2"
                                v-loading="loading"
                                :highlight-current-row="true"
                                show-overflow-tooltip="true"
                                queryData="ProSRMasterViewInfo"
                                :filter_language="['Relation_MPS_Line_ID','SR_StatusName']"
                                :filter_thousandth="['Plan_qty']"
                                border
                                stripe
                                resizable
                                size="mini"
                                :height="tableHeight - reduceTableHeight"
                                @cell-click="editInfovxe"
                                @cell-dblclick="openEdit"
                                @checkbox-all="handleSelectionChange2All"
                                @checkbox-change="handleSelectionChange2"
                                @checkbox-range-end="handleSelectionChange2"
                                :checkbox-config="{highlight: true, range: true}"
                                :mouse-config="{selected:true,area: true, extension: true}"
                                header-row-class-name="headerclass"
                                style="width: 100%; margin-top:0px"
                        >
                            <vxe-table-column type="checkbox" align="center" width="60"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="SR_code" :title="$t('getapi[3663]')" width="100px"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="SR_TYPE_ID" :title="$t('getapi[1122]')" width="100px"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="Part_version" :title="$t('getapi[149]')" width="100px"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="Plan_qty" :title="$t('getapi[2182]')" align="right" width="100px"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="Part_Code" :title="$t('getapi[112]')" width="100px"></vxe-table-column>
                            <vxe-table-column field="Relation_MPS_Line_ID" :title="$t('getapi[4120]')" width="100px">
                                <template scope="scope">
                                    {{scope.row.Relation_MPS_Line_ID | lanchange}}
                                </template>
                            </vxe-table-column>
                            <vxe-table-column field="SR_StatusName" :title="$t('getapi[552]')" width="100px">
                                <template scope="scope">
                                    {{scope.row.SR_StatusName | lanchange}}
                                </template>
                            </vxe-table-column>
                            <vxe-table-column show-footer-overflow field="Plan_date" :title="$t('getapi[1601]')" width="100px"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="Suggest_SO_date" :title="$t('getapi[4122]')" width="100px"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="Item_Code" :title="$t('getapi[3437]')" width="100px"></vxe-table-column>
                            <vxe-table-column field="Bom_Config_Flag" :title="$t('getapi[4123]')" width="100px">
                                <template scope="scope">
                                    {{scope.row.Bom_Config_Flag | lanchange}}
                                </template>
                            </vxe-table-column>
                            <vxe-table-column show-footer-overflow field="Bom_Config_Sign" :title="$t('getapi[4124]')" width="100px"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="Create_Person" :title="$t('getapi[4125]')" width="100px"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="Create_Time" :title="$t('getapi[4126]')" width="100px"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="Modify_Person" :title="$t('getapi[733]')" width="100px"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="Modify_Time" :title="$t('getapi[1210]')" width="100px"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="Audit_Person" :title="$t('getapi[4043]')" width="100px"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="Audit_Time" :title="$t('getapi[4044]')" width="100px"></vxe-table-column>
                        </vxe-table>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[4128]')" name="3">
                        <el-table
                                id="xpane-3"
                                :data="dataSet3"
                                ref="singleTable3"
                                v-loading="loading"
                                :highlight-current-row="true"
                                show-overflow-tooltip="true"
                                queryData="ProSRMasterViewInfo"
                                :filter_language="['Relation_MPS_Line_ID','SR_StatusName']"
                                :filter_thousandth="['Plan_qty']"
                                border
                                stripe
                                size="mini"
                                :height="tableHeight - 30"
                                @row-click="editInfo"
                                @row-dblclick="openEdit"
                                @selection-change="handleSelectionChange3"
                                header-row-class-name="headerclass"
                                style="width: 100%; margin-top:0px"
                        >
                            <el-table-column type="selection"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="SR_code" :label="$t('getapi[3663]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="SR_TYPE_ID" :label="$t('getapi[1122]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Part_version" :label="$t('getapi[149]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Plan_qty" :label="$t('getapi[2182]')" align="right"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Part_Code" :label="$t('getapi[112]')"></el-table-column>
                            <el-table-column prop="Relation_MPS_Line_ID" :label="$t('getapi[4120]')">
                                <template scope="scope">
                                    {{scope.row.Relation_MPS_Line_ID | lanchange}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="SR_StatusName" :label="$t('getapi[552]')">
                                <template scope="scope">
                                    {{scope.row.SR_StatusName | lanchange}}
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Plan_date" :label="$t('getapi[1601]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Suggest_SO_date" :label="$t('getapi[4122]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Item_Code" :label="$t('getapi[3437]')"></el-table-column>
                            <el-table-column prop="Bom_Config_Flag" :label="$t('getapi[4123]')">
                                <template scope="scope">
                                    {{scope.row.Bom_Config_Flag | lanchange}}
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Bom_Config_Sign" :label="$t('getapi[4124]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Create_Person" :label="$t('getapi[4125]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Create_Time" :label="$t('getapi[4126]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Modify_Person" :label="$t('getapi[733]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Modify_Time" :label="$t('getapi[1210]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Audit_Person" :label="$t('getapi[4043]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Audit_Time" :label="$t('getapi[4044]')"></el-table-column>
                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[6096]')" name="4">
                        <div>
                            <el-button type="primary" size="mini" @click="cancelToCreate" :disabled="!btn.cancelToCreate">{{$t('getapi[4480]')}}</el-button>
                            <el-button type="primary" size="mini" @click="toMaterials" :disabled="!btn.toMaterials">{{$t('getapi[7046]')}}</el-button>
                            <el-button type="primary" size="mini" @click="toCraft" :disabled="!btn.toCraft">{{$t('getapi[7047]')}}</el-button>
                            <el-button type="primary" size="mini" @click="getPro" :disabled="!btn.Pro">{{$t('getapi[7045]')}}</el-button>
                        </div>
                        <el-table
                                id="xpane-4"
                                :data="dataSet4"
                                ref="singleTable4"
                                v-loading="loading"
                                :highlight-current-row="true"
                                show-overflow-tooltip="true"
                                queryData="ProSRMasterViewInfo"
                                :filter_language="['Relation_MPS_Line_ID','SR_StatusName']"
                                :filter_thousandth="['Plan_qty']"
                                border
                                stripe
                                size="mini"
                                :height="tableHeight - reduceTableHeight"
                                @row-click="editInfo"
                                @row-dblclick="openEdit"
                                @selection-change="handleSelectionChange4"
                                header-row-class-name="headerclass"
                                style="width: 100%; margin-top:0px"
                        >
                            <el-table-column type="selection"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="SR_code" :label="$t('getapi[3663]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="SR_TYPE_ID" :label="$t('getapi[1122]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Part_version" :label="$t('getapi[149]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Plan_qty" :label="$t('getapi[2182]')" align="right"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Part_Code" :label="$t('getapi[112]')"></el-table-column>
                            <el-table-column prop="Relation_MPS_Line_ID" :label="$t('getapi[4120]')">
                                <template scope="scope">
                                    {{scope.row.Relation_MPS_Line_ID | lanchange}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="SR_StatusName" :label="$t('getapi[552]')">
                                <template scope="scope">
                                    {{scope.row.SR_StatusName | lanchange}}
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Plan_date" :label="$t('getapi[1601]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Suggest_SO_date" :label="$t('getapi[4122]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Item_Code" :label="$t('getapi[3437]')"></el-table-column>
                            <el-table-column prop="Bom_Config_Flag" :label="$t('getapi[4123]')">
                                <template scope="scope">
                                    {{scope.row.Bom_Config_Flag | lanchange}}
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Bom_Config_Sign" :label="$t('getapi[4124]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Create_Person" :label="$t('getapi[4125]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Create_Time" :label="$t('getapi[4126]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Modify_Person" :label="$t('getapi[733]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Modify_Time" :label="$t('getapi[1210]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Audit_Person" :label="$t('getapi[4043]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Audit_Time" :label="$t('getapi[4044]')"></el-table-column>
                        </el-table>
                    </el-tab-pane>
                </el-tabs>
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <div>
                    <div class="btnnowrap">
                        <el-button type="primary" size="mini" @click="billToCreate" :disabled="!btn.billToCreate">{{$t('getapi[7048]')}}
                        </el-button>
                        <el-button type="primary" size="mini" @click="billRelease" :disabled="!btn.billRelease">{{
                            $t('getapi[1488]') }}
                        </el-button>
                        <el-button type="primary" size="mini" @click="billOrder" :disabled="!btn.billOrder">{{
                            $t('getapi[4166]') }}
                        </el-button>
                        <el-button type="primary" size="mini" @click="billCancel" :disabled="!btn.billCancel">{{
                            $t('getapi[3086]') }}
                        </el-button>
                    </div>
                    <div style="width:730px;min-width:730px">
                        <table>
                            <tr>
                                <td style="width:60px;min-width:60px">{{ $t('getapi[3663]') }}</td>
                                <td style="width:150px;min-width:150px">
                                    <el-input type="text" size="mini" v-model="dataDetail.Head.sr_code" :readonly="addoredit != 0" :class="{'readO':addoredit != 0}"></el-input>
                                </td>
                                <td style="width:60px;min-width:60px">{{ $t('getapi[112]') }}</td>
                                <td style="width:150px;min-width:150px">
                                    <routejump :urlNo="12" v-show="dataDetail.Head.sr_status == 0">
                                    <el-input  type="text" v-model="dataDetail.Head.part_code"
                                               readonly
                                               class="mcolor"
                                               size="mini"

                                    >
                                        <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectpart()"></i>
                                    </el-input>
                                    </routejump>
                                    <el-input type="text" size="mini" v-model="dataDetail.Head.part_code" v-show="dataDetail.Head.sr_status != 0" :readonly="true" class="readO"></el-input>
                                </td>
                                <td style="width:60px;min-width:60px">{{ $t('getapi[149]') }}</td>
                                <td style="width:150px;min-width:150px">
                                    <el-input type="text" size="mini" v-model="dataDetail.Head.part_version" :readonly="true" class="readO"></el-input>
                                </td>
                                <td style="width:100px;min-width:100px"><el-checkbox  v-model="dataDetail.Head.relation_mps_line_id"  :true-label=1 :false-label=0 :readonly="true" class="readO"></el-checkbox>{{ $t('getapi[4120]') }}</td>
                            </tr>
                            <tr>
                                <td>{{ $t('getapi[552]') }}</td>
                                <td>
                                    <el-input type="text" size="mini" :value="expStatus(dataDetail.Head.sr_status)" :readonly="true" class="readO"></el-input>
                                </td>
                                <td>{{ $t('getapi[124]') }}</td>
                                <td>
                                    <el-input type="text" size="mini" v-model="dataDetail.Head.part_model" :readonly="true" class="readO"></el-input>
                                </td>
                                <td>{{ $t('getapi[125]') }}</td>
                                <td colspan="2">
                                    <el-input type="text" size="mini" v-model="dataDetail.Head.part_spec" :readonly="true" class="readO"></el-input>
                                </td>
                            </tr>
                            <tr>
                                <td>{{ $t('getapi[1479]') }}</td>
                                <td>
                                    <routejump :urlNo="5" v-show="dataDetail.Head.sr_status == 0">
                                    <el-input  type="text" v-model="dataDetail.Head.item_code"
                                               readonly
                                               size="mini"

                                    >
                                        <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectitem()"></i>
                                    </el-input>
                                    </routejump>
                                    <el-input type="text" size="mini" v-model="dataDetail.Head.item_code" v-show="dataDetail.Head.sr_status != 0" :readonly="true" class="readO"></el-input>
                                </td>
                                <td>{{ $t('getapi[2182]') }}</td>
                                <td>
                                    <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.Head.plan_qty" :readonly="dataDetail.Head.sr_status != 0" :class="{'readO':dataDetail.Head.sr_status != 0}"></el-input>
                                </td>
                                <td>{{ $t('getapi[888]') }}</td>
                                <td>
                                    <el-input type="text" size="mini" v-model="dataDetail.Head.part_master_unit" :readonly="true" class="readO"></el-input>
                                </td>
                            </tr>
                            <tr>
                                <td>{{ $t('getapi[1122]') }}</td>
                                <td>
                                    <routejump :urlNo="43">
                                    <el-select filterable v-model="dataDetail.Head.sr_type_id" size="mini" :disabled="dataDetail.Head.sr_status != 0">
                                        <el-option v-for="item in srType" :key="item.Code" :label="item.Name"
                                                   :value="item.Code"></el-option>
                                    </el-select>
                                    </routejump>
                                </td>
                                <td>{{ $t('getapi[2573]') }}</td>
                                <td>
                                    <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.Head.kcqty" :readonly="true" class="readO"></el-input>
                                </td>
                                <td>{{ $t('getapi[4121]') }}</td>
                                <td>
                                    <el-date-picker v-model="dataDetail.Head.plan_date" type="date" size="mini" value-format="yyyy-MM-dd"
                                                    style="width:100%" :readonly="dataDetail.Head.sr_status != 0" :class="{'readO':dataDetail.Head.sr_status != 0}"></el-date-picker>
                                </td>
                            </tr>
                            <tr>
                                <td>{{ $t('getapi[4168]') }}</td>
                                <td>
                                    <el-input type="text" size="mini" v-model="dataDetail.Head.so_code" :readonly="true" class="readO"></el-input>
                                </td>
                                <td></td>
                                <td>
                                    <el-checkbox  v-model="dataDetail.Head.bom_config_flag"  :true-label=1 :false-label=0 :readonly="true" class="readO"></el-checkbox>{{ $t('getapi[4123]') }}
                                </td>
                                <td>{{ $t('getapi[3662]') }}</td>
                                <td>
                                    <el-select filterable v-model="dataDetail.Head.bom_config_sign" size="mini" :disabled="dataDetail.Head.sr_status != 0 || dataDetail.Head.bom_config_flag == 0">
                                        <el-option v-for="item in SignList" :key="item.config_sign" :label="item.config_sign"
                                                   :value="item.config_sign"></el-option>
                                    </el-select>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </li>
        </ul>
        <el-row v-if="SelectIndex == 0" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <el-row v-if="SelectIndex == 1" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange1"
                        @current-change="handleCurrentChange1"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize1"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total1"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <el-row v-if="SelectIndex == 2" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange2"
                        @current-change="handleCurrentChange2"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize2"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total2"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <el-row v-if="SelectIndex == 3" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange3"
                        @current-change="handleCurrentChange3"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize3"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total3"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <el-row v-if="SelectIndex == 4" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange4"
                        @current-change="handleCurrentChange4"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize4"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total4"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="ProSRMasterViewInfo" ref="ser" @getser="serclick"></serce>
        <!--选择物料-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Pro/SR/GetPartInfoPopupList'" @callback="getpart" ref="part"></selector>
        <!--选择项目-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Pro/SR/GetItemInfoPopupList'" @callback="getitem" ref="item"></selector>

        <el-dialog v-dialogDrag :visible.sync="visOrder" :title="$t('getapi[7049]')" width="25%" :close-on-click-modal="false" >
            <table>
                <tr>
                    <td style="width:60px">{{ $t('getapi[4209]') }}</td>
                    <td style="width:200px" colspan="2"><el-input v-model="orderDetail.plancode" type="text"></el-input></td>
                </tr>
                <tr>
                    <td></td>
                    <td style="width:100px"><el-checkbox v-model="orderDetail.issrso" true-label="1" false-label="0"></el-checkbox>
                        {{ $t('getapi[7050]') }}</td>
                    <td style="width:100px"><el-checkbox v-model="orderDetail.isnewflag" true-label="1" false-label="0"></el-checkbox>
                        {{ $t('getapi[4218]') }}</td>
                </tr>
                <tr>
                    <td>{{ $t('getapi[4217]') }}</td>
                    <td style="width:100px">
                        <el-select filterable v-model="orderDetail.sotype" size="mini">
                            <el-option key="0" :label="$t('getapi[2406]')" value='0'></el-option>
                            <el-option key="1" :label="$t('getapi[7051]')" value='1'></el-option>
                            <el-option key="2" :label="$t('getapi[7052]')" value='2'></el-option>
                        </el-select>
                    </td>
                    <td style="width:100px"><el-checkbox v-model="orderDetail.issselfbadflag" true-label="1" false-label="0"></el-checkbox>
                        {{ $t('getapi[4254]') }}</td>
                </tr>
            </table>
            <span slot="footer" class="dialog-footer">
				<el-button @click="visOrder = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button type="primary" @click="confirmBillOrder(0)" :disabled="!btn.confirmbillorder">{{ $t('getapi[1146]') }}</el-button>
			</span>
        </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import { Loading } from 'element-ui';
    export default {
        name: '2_srview',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                dataSet: [], // 主表数据
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('2_srview'), // 当前页数据量
                total: 0, // 数据总量
                SelectIndex: 0, //当前页面
                dataSet1: [], // 主表数据
                pageIndex1: 1, // 当前页
                pageSize1: this.$http.getPageSize('2_srview1'), // 当前页数据量
                total1: 0, // 数据总量
                dataSet2: [], // 主表数据
                pageIndex2: 1, // 当前页
                pageSize2: this.$http.getPageSize('2_srview2'), // 当前页数据量
                total2: 0, // 数据总量
                dataSet3: [], // 主表数据
                pageIndex3: 1, // 当前页
                pageSize3: this.$http.getPageSize('2_srview3'), // 当前页数据量
                total3: 0, // 数据总量
                dataSet4: [], // 主表数据
                pageIndex4: 1, // 当前页
                pageSize4: this.$http.getPageSize('2_srview4'), // 当前页数据量
                total4: 0, // 数据总量
                loading: false, // 主表加载状态
                reduceTableHeight: Common.reduceTableHeight1_1,
                dataDetail:{
                    Head:{},
                },
                oldDataDetail: '',
                SignList: [],
                selectData: [],
                selectData1: [],
                selectData2: [],
                selectData3: [],
                selectData4: [],
                btn:{
                    batchDel: false,
                    batchRelease: false,
                    Pro: false,
                    toMaterials: false,
                    toCraft: false,
                    releaseToCreate: false,
                    batchCancel: false,
                    bulkOrder: false,
                    cancelToCreate: false,
                    billToCreate: false,
                    billRelease: false,
                    billOrder:false,
                    billCancel:false,
                    confirmbillorder: true,
                },
                srType: [],//sr类别
                orderDetail: {
                    plancode: '',
                    issrso: '0',
                    isnewflag: '0',
                    sotype: '0',
                    flag: 1,
                    issselfbadflag: '0',
                    iscontinue: 0,
                },
                visOrder: false,
                orderType: 1,
                oldrow: '',
                iscontinuedblclick: true,
                timeId: null,
                scrollTop:0,
                scrollTop1:0,
                scrollTop2:0,
                scrollTop3:0,
                scrollTop4:0,
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(that.SelectIndex)
                })
            },
            dataSet1: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(that.SelectIndex)
                })
            },
            dataSet2: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(that.SelectIndex)
                })
            },
            dataSet3: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(that.SelectIndex)
                })
            },
            dataSet4: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(that.SelectIndex)
                })
            },
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
                that.$refs.singleTable2.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop2 = res.target.scrollTop
                },false)
                that.$refs.singleTable3.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop3 = res.target.scrollTop
                },false)
                that.$refs.singleTable4.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop4 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.bodyWrapper.scrollTop =this.scrollTop1;
                    this.$refs.singleTable2.bodyWrapper.scrollTop =this.scrollTop2;
                    this.$refs.singleTable3.bodyWrapper.scrollTop =this.scrollTop3;
                    this.$refs.singleTable4.bodyWrapper.scrollTop =this.scrollTop4;
                }, 13)
            })
        },
        mounted: function () {
            let that = this;
            that.$processdata.pushModelCache('2_srview', that)
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username;
            that.srType = Array.methods.getSrType();
            that.$limits.dragControllerDiv();
            that.oldDataDetail = JSON.stringify(that.dataDetail)
            that.confirmAdd()
        },
        beforeRouteEnter(to, form, next) {
            next(vm => {
                if (form.name == 'prorelation' && Object.keys(vm.$store.state.sharedParams).length > 0) {
                    const data = {...vm.$store.state.sharedParams};
                    vm.getDetail(data.order_no);
                    setTimeout(() => {
                        vm.openEdit()
                    }, 500);
                    vm.$store.commit('clearSharedParams')
                }
            });
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[3997]"),this.$t("getapi[25]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority(type) {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                if (type == 1) {
                    //只读权
                    if (that.$limits.ReadOnlyRightsView('plv2', 177, 1, that.total)) {
                        if (that.total > 0) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh');
                        }
                    }
                    //操作权限-查询级别
                    var limits = that.$limits.OperationAuthorityView('plv2', 177, 1, that.total);
                    // limits说明： 1 查询权限、2 编辑权限、3 删除权限(列表行数>0)、4 删除权限(列表行数<0)
                    switch (limits) {
                        case -1:
                            that.$refs.SetBtn.SetButtonEnable('search,refresh');
                            break;
                        case 1:
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                            break;
                        case -2:
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh');
                            break;
                        case 2:
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                            break;
                        case -3:
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh');
                            break;
                        case 3:
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                            break;
                        default:
                            break;
                    }
                }

                //管理界面
                if (type == 2) {
                    if (that.$limits.authority('plv2', 178, 1) == 1) {
                        //只读权
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    if (that.$limits.authority('plv2', 178, 1) == 2) {
						if (that.$limits.authority('plv3', 178,1) == 0) {
							that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
						}
                        //操作权
                        if (that.$limits.authority('plv3', 178,1) == 1) {
                            //编辑级
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,import,export');
                        }
                        if (that.$limits.authority('plv3', 178, 1) == 2) {
                            //删除级
                            if (!that.$limits.fnIsEmpty(that.dataDetail.Head.sr_code)) {
                                if(that.dataDetail.Head.sr_status > 0){
                                    that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,import,export');
                                } else {
                                    that.$refs.SetBtn.SetButtonEnable('create,save,del,search,refresh,import,export');
                                }
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,import,export');
                            }
                        }
                    }
                }
                that.btnauthority();
            },
            btnauthority() {
                let that = this
                that.btn.Pro = false
                that.btn.toMaterials = false
                that.btn.toCraft = false
                if(that.SelectIndex == 0){
                    if(that.selectData.length  == 1){
                        that.btn.Pro = true
                    }
                } else if(that.SelectIndex == 1){
                    if(that.selectData1.length  == 1){
                        that.btn.Pro = true
                        that.btn.toMaterials = true
                        that.btn.toCraft = true
                    }
                } else if(that.SelectIndex == 2){
                    if(that.selectData2.length  == 1){
                        that.btn.Pro = true
                        that.btn.toMaterials = true
                        that.btn.toCraft = true
                    }
                } else if(that.SelectIndex == 4){
                    if(that.selectData4.length  == 1){
                        that.btn.Pro = true
                        that.btn.toMaterials = true
                        that.btn.toCraft = true
                    }
                }
                that.btn.batchDel = false
                that.btn.batchRelease = false
                that.btn.releaseToCreate = false
                that.btn.batchCancel= false
                that.btn.bulkOrder= false
                if(that.$limits.authority('plv3', 177,1) == 0){
                    that.btn.batchDel = false
                    that.btn.batchRelease = false
                    that.btn.releaseToCreate = false
                    that.btn.batchCancel= false
                    that.btn.bulkOrder= false
                }
                if(that.$limits.authority('plv3', 177,1) > 0){
                    if(that.$limits.authority('plv4', 91,1) == 0){
                        that.btn.batchDel = false
                    }
                    if(that.$limits.authority('plv4', 91,1) == 1){
                        if(that.selectData1.length > 0) {
                            that.btn.batchDel = true
                        }
                    }
                    if(that.$limits.authority('plv4', 92,1) == 0){
                        that.btn.batchRelease = false
                    }
                    if(that.$limits.authority('plv4', 92,1) == 1){
                        if(that.selectData1.length > 0) {
                            that.btn.batchRelease = true
                        }
                    }
                    if(that.$limits.authority('plv4', 94,1) == 0){
                        that.btn.releaseToCreate = false
                    }
                    if(that.$limits.authority('plv4', 94,1) == 1){
                        if(that.selectData2.length == 1) {
                            that.btn.releaseToCreate = true
                        }
                    }
                    if(that.$limits.authority('plv4', 130,1) == 0){
                        that.btn.batchCancel = false
                    }
                    if(that.$limits.authority('plv4', 130,1) == 1){
                        if(that.selectData2.length > 0) {
                            that.btn.batchCancel = true
                        }
                    }
                    if(that.$limits.authority('plv4', 95,1) == 0){
                        that.btn.bulkOrder = false
                    }
                    if(that.$limits.authority('plv4', 95,1) == 1){
                        if(that.selectData2.length > 0) {
                            that.btn.bulkOrder = true
                        }
                    }
                }
                that.btn.cancelToCreate = false
                if(that.selectData4.length == 1){
                    that.btn.cancelToCreate = true
                }
                that.btn.billToCreate= false
                that.btn.billRelease=false
                that.btn.billOrder=false
                that.btn.billCancel=false
                if(that.dataDetail.Head.sr_code == ''){
                    that.btn.billToCreate= false
                    that.btn.billRelease=false
                    that.btn.billOrder=false
                    that.btn.billCancel=false
                    return
                }
                if(that.$limits.authority('plv3', 178,1) == 0){
                    that.btn.billToCreate= false
                    that.btn.billRelease=false
                    that.btn.billOrder=false
                    that.btn.billCancel=false
                    return
                }
                //生成状态
                if(that.dataDetail.Head.sr_status == 0){
                    that.btn.billToCreate= false
                    that.btn.billRelease=true
                    if(that.$limits.authority('plv3', 178,1) > 0){
                        if(that.$limits.authority('plv4', 100,1) == 0){
                            that.btn.billRelease=false
                        }
                        if(that.$limits.authority('plv4', 100,1) == 1){
                            that.btn.billRelease=true
                        }
                    }
                    that.btn.billOrder=false
                    that.btn.billCancel=false
                }
                // 下达状态
                if(that.dataDetail.Head.sr_status == 1){
                    if(that.$limits.authority('plv3', 178,1) > 0){
                        if(that.$limits.authority('plv4', 99,1) == 0){
                            that.btn.billToCreate= false
                        }
                        if(that.$limits.authority('plv4', 99,1) == 1){
                            that.btn.billToCreate= true
                        }
                        if(that.$limits.authority('plv4', 101,1) == 0){
                            that.btn.billOrder= false
                        }
                        if(that.$limits.authority('plv4', 101,1) == 1){
                            that.btn.billOrder= true
                        }
                        if(that.$limits.authority('plv4', 102,1) == 0){
                            that.btn.billCancel= false
                        }
                        if(that.$limits.authority('plv4', 102,1) == 1){
                            that.btn.billCancel= true
                        }
                    }
                    that.btn.billRelease=false
                }
                if(that.dataDetail.Head.sr_status == 2){
                    that.btn.billToCreate= false
                    that.btn.billRelease=false
                    that.btn.billOrder=false
                    that.btn.billCancel=false
                }
                if(that.dataDetail.Head.sr_status == 3){
                    that.btn.billToCreate= false
                    that.btn.billRelease=false
                    that.btn.billOrder=false
                    that.btn.billCancel=false
                }
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if(!that.iscontinuedblclick){
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('2_srview',val)
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
            },
            handleSizeChange1(val) {
                this.pageSize1 = val;
                this.$http.savePageSize('2_srview1',val)
                this.getView();
            },
            handleCurrentChange1(val) {
                this.pageIndex1 = val;
                this.getView();
            },
            handleSizeChange2(val) {
                this.pageSize2 = val;
                this.$http.savePageSize('2_srview2',val)
                this.getView();
            },
            handleCurrentChange2(val) {
                this.pageIndex2 = val;
                this.getView();
            },
            handleSizeChange3(val) {
                this.pageSize3 = val;
                this.$http.savePageSize('2_srview3',val)
                this.getView();
            },
            handleCurrentChange3(val) {
                this.pageIndex3 = val;
                this.getView();
            },
            handleSizeChange4(val) {
                this.pageSize4 = val;
                this.$http.savePageSize('2_srview4',val)
                this.getView();
            },
            handleCurrentChange4(val) {
                this.pageIndex4 = val;
                this.getView();
            },
            selectInfo(tab, event) {
                let that = this;
                that.SelectIndex = tab.name;
                that.getView();
                that.$nextTick(function(){
                    that.$processdata.initForm(that.SelectIndex)
                });
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'ProSRMasterViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndex,
                    Param: datac
                };
                if(that.SelectIndex == 0){
                    data.PageIndex = that.pageIndex
                    data.PageSize = that.pageSize
                } else if(that.SelectIndex == 1){
                    data.PageIndex = that.pageIndex1
                    data.PageSize = that.pageSize1
                } else if(that.SelectIndex == 2){
                    data.PageIndex = that.pageIndex2
                    data.PageSize = that.pageSize2
                } else if(that.SelectIndex == 3){
                    data.PageIndex = that.pageIndex3
                    data.PageSize = that.pageSize3
                } else if(that.SelectIndex == 4){
                    data.PageIndex = that.pageIndex4
                    data.PageSize = that.pageSize4
                }
                that.$http.urlpost('/Pro/SR/SRViewDataList', data, function (res) {
                    if (res.Success == 1) {
                        if (that.SelectIndex == 0) {
                            that.dataSet = res.DataContent;
                            that.total = res.Totals;
                        } else if (that.SelectIndex == 1) {
                            that.dataSet1 = res.DataContent;
                            that.total1 = res.Totals;
                        } else if (that.SelectIndex == 2) {
                            that.dataSet2 = res.DataContent;
                            that.total2 = res.Totals;
                        } else if (that.SelectIndex == 3) {
                            that.dataSet3 = res.DataContent;
                            that.total3 = res.Totals;
                        } else if (that.SelectIndex == 4) {
                            that.dataSet4 = res.DataContent;
                            that.total4 = res.Totals;
                        }
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                    } else {
                        that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                });
            },
            // 根据ID获取详情数据
            editInfo(row) {
                let that = this
                if(that.code == row.SR_code){
                    return
                }
                console.log(row)
                that.timeId = setTimeout(() => {
                    if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.iscontinuedblclick = true
                                that.oldrow = row
                                that.code = row.SR_code
                                that.getDetail(row.SR_code)
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                if (that.SelectIndex == 0) {
                                    that.$refs.singleTable.setCurrentRow(that.oldrow);
                                } else if (that.SelectIndex == 1) {
                                    that.$refs.singleTable1.setCurrentRow(that.oldrow);
                                } else if (that.SelectIndex == 2) {
                                    that.$refs.singleTable2.setCurrentRow(that.oldrow);
                                } else if (that.SelectIndex == 3) {
                                    that.$refs.singleTable3.setCurrentRow(that.oldrow);
                                } else if (that.SelectIndex == 4) {
                                    that.$refs.singleTable4.setCurrentRow(that.oldrow);
                                }
                            });
                    } else {
                        that.iscontinuedblclick = true
                        that.oldrow = row
                        that.code = row.SR_code
                        that.getDetail(row.SR_code)
                    }
                }, 100);
            },
            editInfovxe(row) {
                let that = this
                console.log(row)
                that.timeId = setTimeout(() => {
                    if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.iscontinuedblclick = true
                                that.oldrow = row.row
                                that.code = row.row.SR_code
                                that.getDetail(row.row.SR_code)
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                if (that.SelectIndex == 0) {
                                    that.$refs.singleTable.setCurrentRow(that.oldrow);
                                } else if (that.SelectIndex == 1) {
                                    that.$refs.singleTable1.setCurrentRow(that.oldrow);
                                } else if (that.SelectIndex == 2) {
                                    that.$refs.singleTable2.setCurrentRow(that.oldrow);
                                } else if (that.SelectIndex == 3) {
                                    that.$refs.singleTable3.setCurrentRow(that.oldrow);
                                } else if (that.SelectIndex == 4) {
                                    that.$refs.singleTable4.setCurrentRow(that.oldrow);
                                }
                            });
                    } else {
                        that.iscontinuedblclick = true
                        that.oldrow = row.row
                        that.code = row.row.SR_code
                        that.getDetail(row.row.SR_code)
                    }
                }, 100);
            },
            // 新增
            add() {
                let that = this;
                if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd()
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd()
                }
            },
            confirmAdd(){
                let that = this;
                that.addoredit = 0
                that.code = ''
                let date = Common.methods.getDate()
                that.dataDetail.Head = {
                    isadd: 1,
                    so_code: '',
                    sr_code: '',
                    relation_mps_line_id: 0,
                    part_code: '',
                    part_version: '',
                    part_id: 0,
                    part_model: '',
                    part_master_unit: '',
                    kcqty: 0,
                    part_spec: '',
                    sr_type_id: '',
                    sr_type_name: '',
                    item_code: '',
                    plan_qty: 0,
                    plan_date: date,
                    suggest_so_date: '',
                    sr_status: 0,
                    create_person: '',
                    create_time: '',
                    modify_person: '',
                    modify_time: '',
                    audit_person: '',
                    audit_time: '',
                    schedule_person: '',
                    remark1: '',
                    remark2: '',
                    field: '',
                    bom_config_flag: 0,
                    bom_config_sign: ''
                }
                that.oldDataDetail = JSON.stringify(that.dataDetail)
                that.authority(2);
            },
            // 刷新
            reflash() {
                let that = this;
                if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            if(that.addoredit == 0){
                                that.getView();
                                that.confirmAdd()
                            } else {
                                that.getView();
                                that.getDetail(that.code)
                            }
                        });
                } else {
                    if(that.addoredit == 0){
                        that.getView();
                        that.confirmAdd()
                    } else {
                        that.getView();
                        that.getDetail(that.code)
                    }
                }
            },
            // 导出
            exps() {
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac,
                    LangType:that.$processdata.getLang(),
                    fromname: that.$t('getapi[3997]')
                };
                that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                that.$http.urlpost('/Pro/SR/SRViewExportToExecl', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            // 保存
            save() {
                let that = this;
                let parm = {
                    Head:that.dataDetail.Head,
                    LangType: that.$processdata.getLang(),
                }
                that.$http.urlpost('/Pro/SR/SRSaveData', parm, function(res) {
                    if (res.Success == 1) {
                        that.$message({
                            duration: 0,
                            showClose: true,
                            message: that.$processdata.explainCallbackMsg(res.Msg),
                            type: 'success'
                        })
                        that.code = res.UniqueNum
                        that.getDetail(res.UniqueNum)
                    }
                });
            },
            getDetail(code) {
                let that = this;
                that.addoredit = 1
                let parm = {
                    Code: code
                };
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('/Pro/SR/GetSrBillInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent;
                        that.dataDetail.Head.sr_type_id = that.dataDetail.Head.sr_type_id.toString()
                        that.SignList = that.dataDetail.SignList
                        that.oldDataDetail = JSON.stringify(that.dataDetail)
                        that.authority(2);
                        that.btnauthority()
                    }
                    loadingInstance.close()
                });
            },
            handleSelectionChange(val){
                let that = this;
                that.selectData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData.push(val[i]);
                }
                that.btnauthority()
            },
            handleSelectionChange1All({ records }){
                let that = this
                that.selectData1 = records
                that.btnauthority()
            },
            handleSelectionChange1({checked, records }){
                let that = this;
                that.selectData1 = [];
                that.selectData1 = records
                that.btnauthority()
            },
            handleSelectionChange2All({ records }){
                let that = this
                that.selectData2 = records
                that.btnauthority()
            },
            handleSelectionChange2({checked, records }){
                let that = this;
                that.selectData2 = records
                that.btnauthority()
            },
            handleSelectionChange3(val){
                let that = this;
                that.selectData3 = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData3.push(val[i]);
                }
                that.btnauthority()
            },
            handleSelectionChange4(val){
                let that = this;
                that.selectData4 = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData4.push(val[i]);
                }
                that.btnauthority()
            },
            // 生产业务图
            getPro(){
                let that = this
                let data = {}
                if(that.SelectIndex == 0){
                    data = that.selectData[0]
                } else if (that.SelectIndex == 1){
                    data = that.selectData1[0]
                } else if (that.SelectIndex == 2){
                    data = that.selectData2[0]
                } else if (that.SelectIndex == 4){
                    data = that.selectData4[0]
                }
                that.$store.commit('setSharedParams',data);
                let item = {
                    label: '生产关系图',
                    name: 'prorelation',
                    path: '/prorelation/sr',
                    url: '/prorelation/sr',
                    icon: 'video-play'
                };
                this.$router.push({ path: '/prorelation/sr'});
                this.$store.commit('selectMenu', item);
                this.$limits.cachePage(item)
            },
            toMaterials(){
                let that = this
                let data = {}
                if (that.SelectIndex == 1){
                    data = that.selectData1[0]
                } else if (that.SelectIndex == 2){
                    data = that.selectData2[0]
                } else if (that.SelectIndex == 4){
                    data = that.selectData4[0]
                }
                that.$store.commit('setSharedParams',data);
                let item = {
                    label: this.$t("getapi[56]"),
                    name: 'mater',
                    path: '/mater',
                    url: '/mater',
                    icon: 'video-play'
                };
                this.$router.push({ path: '/mater'});
                this.$store.commit('selectMenu', item);
                this.$limits.cachePage(item)
            },
            toCraft(){
                let that = this
                let data = {}
                if (that.SelectIndex == 1){
                    data = that.selectData1[0]
                } else if (that.SelectIndex == 2){
                    data = that.selectData2[0]
                } else if (that.SelectIndex == 4){
                    data = that.selectData4[0]
                }
                that.$store.commit('setSharedParams',data);
                let item = {
                    label: this.$t("getapi[64]"),
                    name: 'carft',
                    path: '/carft',
                    url: '/carft',
                    icon: 'video-play'
                };
                this.$router.push({ path: 'carft'});
                this.$store.commit('selectMenu', item);
                this.$limits.cachePage(item)
            },
            //批量删除
            batchDel(){
                let that = this
                let arr = []
                if(that.selectData1.length == 0){
                    that.$message.warning(that.$t('getapi[1158]'))//请选择数据！
                    return
                }
                for(let i = 0;i<that.selectData1.length;i++){
                    arr = [...arr,{
                        sr_code: that.selectData1[i].SR_code,
                    }]
                }
                let parm = {
                    Lists: arr
                }
                that.$http.urlpost('/Pro/SR/SRDelLine', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message({
                            duration: 0,
                            showClose: true,
                            message: that.$processdata.explainCallbackMsg(res.Msg),
                            type: 'success'
                        })
                        that.getView()
                    }
                });
            },
            //批量下达
            batchRelease(){
                let that = this
                let arr = []
                if(that.selectData1.length == 0){
                    that.$message.warning(that.$t('getapi[1158]'))//请选择数据！
                    return
                }
                for(let i = 0;i<that.selectData1.length;i++){
                    arr = [...arr,{
                        sr_code: that.selectData1[i].SR_code,
                    }]
                }
                let parm = {
                    Lists: arr,
                    LangType: that.$processdata.getLang(),
                }
                that.$http.urlpost('/Pro/SR/SRRelease', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message({
                            duration: 0,
                            showClose: true,
                            message: that.$processdata.explainCallbackMsg(res.Msg),
                            type: 'success'
                        })
                        that.getView()
                    }
                });
            },
            //撤销下达
            releaseToCreate(){
                let that = this
                let parm = {
                    sr_code: that.selectData2[0].SR_code
                }
                that.$http.urlpost('/Pro/SR/SRReleaseToCreate', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message({
                            duration: 0,
                            showClose: true,
                            message: that.$processdata.explainCallbackMsg(res.Msg),
                            type: 'success'
                        })
                        that.getView()
                    }
                });
            },
            //取消
            batchCancel(){
                let that = this
                let arr = []
                if(that.selectData2.length == 0){
                    that.$message.warning(that.$t('getapi[1158]'))//请选择数据！
                    return
                }
                for(let i = 0;i<that.selectData2.length;i++){
                    arr = [...arr,{
                        sr_code: that.selectData2[i].SR_code,
                    }]
                }
                let parm = {
                    Lists: arr
                }
                that.$http.urlpost('/Pro/SR/SRBatchCancel', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message({
                            duration: 0,
                            showClose: true,
                            message: that.$processdata.explainCallbackMsg(res.Msg),
                            type: 'success'
                        })
                        that.getView()
                    }
                });
            },
            //生成
            cancelToCreate(){
                let that = this
                let parm = {
                    sr_code: that.selectData4[0].SR_code,
                }
                that.$http.urlpost('/Pro/SR/SRCancelToCreate', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message({
                            duration: 0,
                            showClose: true,
                            message: that.$processdata.explainCallbackMsg(res.Msg),
                            type: 'success'
                        })
                        that.getView()
                    }
                });
            },
            expStatus(val){
                let that = this
              if(val == 0){
                  return that.$t('getapi[1422]')//'生成'
              } else if(val == 1){
                  return that.$t('getapi[1488]')//'下达'
              } else if(val == 2){
                  return that.$t('getapi[1489]')//'已下单'
              } else if(val == 3){
                  return that.$t('getapi[2054]')
              } else {
                  return ''
              }
            },
            del(){
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            sr_code : that.dataDetail.Head.sr_code,
                            sr_status:that.dataDetail.Head.sr_status
                        }
                        that.$refs.SetBtn.SetOneBtnEnable('del',false);
                        that.$http.urlpost('/Pro/SR/DelSr', parm, function (res) {
                            that.$refs.SetBtn.SetOneBtnEnable('del',true);
                            if (res.Success == 1) {
                                that.$message({
                                    duration: 0,
                                    showClose: true,
                                    message: that.$processdata.explainCallbackMsg(res.Msg),
                                    type: 'success'
                                })
                                that.getView()
                                that.confirmAdd()
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            //获取物料
            selectpart() {
                let that = this;
                that.$refs.part.clearInput(true);
            },
            getpart(data){
                let that = this
                console.log(data)
                that.dataDetail.Head.part_code = data.part_code
                that.dataDetail.Head.part_model = data.part_model
                that.dataDetail.Head.part_spec = data.part_spec
                that.dataDetail.Head.part_version = data.part_version
                that.dataDetail.Head.part_master_unit = data.part_master_unit
                that.dataDetail.Head.item_code = data.Item_Code
                that.dataDetail.Head.kcqty = data.kcqty
                that.dataDetail.Head.bom_config_flag = data.bom_config_flag.toString()
                that.dataDetail.Head.relation_mps_line_id = 1
                that.getSignList(data.exclusively_id)
            },
            getSignList(id){
              let that = this
              let parm = {
                  Id: id
              }
                that.$http.urlpost('/Pro/SR/GetSrSignsByPartId', parm, function (res) {
                    if (res.Success == 1) {
                        that.SignList = res.DataContent.DataList
                    }
                });
            },
            selectitem() {
                let that = this;
                that.$refs.item.clearInput(true);
            },
            getitem(data){
                let that = this
                console.log(data)
                that.dataDetail.Head.item_code = data.item_code
            },
            //撤销下达
            billToCreate(){
                let that = this
                let parm = {
                    sr_code: that.dataDetail.Head.sr_code,
                    sr_status: that.dataDetail.Head.sr_status,
                    modify_time: that.dataDetail.Head.modify_time
                }
                that.$http.urlpost('/Pro/SR/SRBillToCreate', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message({
                            duration: 0,
                            showClose: true,
                            message: that.$processdata.explainCallbackMsg(res.Msg),
                            type: 'success'
                        })
                        that.getView()
                        that.getDetail(that.code)
                    }
                });
            },
            //下达
            billRelease(){
                let that = this
                let parm = {
                    sr_code: that.dataDetail.Head.sr_code,
                    sr_status: that.dataDetail.Head.sr_status,
                    modify_time: that.dataDetail.Head.modify_time,
                    part_code: that.dataDetail.Head.part_code,
                    part_id: that.dataDetail.Head.part_id,
                    part_version: that.dataDetail.Head.part_version,
                    bom_config_sign: that.dataDetail.Head.bom_config_sign
                }
                that.$http.urlpost('/Pro/SR/SRBillRelease', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message({
                            duration: 0,
                            showClose: true,
                            message: that.$processdata.explainCallbackMsg(res.Msg),
                            type: 'success'
                        })
                        that.getView()
                        that.getDetail(that.code)
                    }
                });
            },
            //下单
            billOrder(){
                let that = this
                that.visOrder = true
                that.orderType = 2 //1:批量下单2：下单
                that.orderDetail = {
                    plancode: '',
                    issrso: '1',//SO与SR号相同 默认勾选
                    isnewflag: '0',
                    sotype: '0',
                    flag: 1,
                    issselfbadflag: '0',
                    iscontinue: 0,
                }
            },
            //批量下单
            bulkOrder(){
                let that = this
                that.visOrder = true
                that.orderType = 1 //1:批量下单2：下单
                that.orderDetail = {
                    plancode: '',
                    issrso: '0',
                    isnewflag: '0',
                    sotype: '0',
                    flag: 1,
                    issselfbadflag: '0',
                    iscontinue: 0,
                }
            },
            confirmBillOrder(value){
                let that = this
                that.orderDetail.iscontinue = value
                if(that.orderType == 1){
                    let arr = []
                    if(that.selectData2.length == 0){
                        that.$message.warning(that.$t('getapi[1158]'))//请选择数据！
                        return
                    }
                    for(let i = 0;i<that.selectData2.length;i++){
                        arr = [...arr,{
                            sr_code: that.selectData2[i].SR_code,
                            part_id: that.selectData2[i].Part_Id,
                            part_code: that.selectData2[i].Part_Code,
                            part_version: that.selectData2[i].Part_version,
                            item_code: that.selectData2[i].Item_Code,
                            plan_qty: that.selectData2[i].Plan_qty,
                            plan_date: that.selectData2[i].Plan_date,
                            bom_config_flag: that.selectData2[i].Bom_Config_Flag,
                            bom_config_sign: that.selectData2[i].Bom_Config_Sign
                        }]
                    }
                    let parm = {
                        plancode: that.orderDetail.plancode,
                        issrso: that.orderDetail.issrso,
                        isnewflag: that.orderDetail.isnewflag,
                        sotype: that.orderDetail.sotype,
                        flag: that.orderDetail.flag,
                        issselfbadflag: that.orderDetail.issselfbadflag,
                        iscontinue: that.orderDetail.iscontinue,
                        LangType: that.$processdata.getLang(),
                        Lists: arr
                    }
                    that.btn.confirmbillorder = false
                    let loadingInstance = Loading.service(Common.maskoption1);
                    that.$http.urlpost('/Pro/SR/SRBulkOrder', parm, function (res) {
                        that.btn.confirmbillorder = true
                        if (res.Success == 1) {
                            that.$message({
                                duration: 0,
                                showClose: true,
                                message: that.$processdata.explainCallbackMsg(res.Msg),
                                type: 'success'
                            })
                            that.visOrder = false
                            that.getView()
                        } else if(res.Success > 1){
                            that.$confirm(that.$processdata.explainCallbackMsg(res.Msg), that.$t('getapi[194]'), {
                                confirmButtonText: that.$t('getapi[1146]'),
                                cancelButtonText: that.$t('getapi[2054]'),
                                type: 'warning'
                            })
                                .then(() => {
                                    that.confirmBillOrder(res.Success)
                                })
                                .catch(() => {
                                    this.$message({
                                        type: 'info',
                                        message: that.$t('getapi[6096]')
                                    });
                                });
                        }
                        loadingInstance.close()
                    });
                } else if(that.orderType == 2){
                    let parm = {
                        plancode: that.orderDetail.plancode,
                        issrso: that.orderDetail.issrso,
                        isnewflag: that.orderDetail.isnewflag,
                        sotype: that.orderDetail.sotype,
                        flag: that.orderDetail.flag,
                        issselfbadflag: that.orderDetail.issselfbadflag,
                        iscontinue: that.orderDetail.iscontinue,
                        so_code: that.dataDetail.Head.so_code,
                        sr_code: that.dataDetail.Head.sr_code,
                        part_id: that.dataDetail.Head.part_id,
                        part_code: that.dataDetail.Head.part_code,
                        part_version: that.dataDetail.Head.part_version,
                        item_code: that.dataDetail.Head.item_code,
                        plan_qty: that.dataDetail.Head.plan_qty,
                        plan_date: that.dataDetail.Head.plan_date,
                        bom_config_flag: that.dataDetail.Head.bom_config_flag,
                        bom_config_sign: that.dataDetail.Head.bom_config_sign,
                        sr_status: that.dataDetail.Head.sr_status,
                        modify_time: that.dataDetail.Head.modify_time,
                        LangType: that.$processdata.getLang(),
                    }
                    that.$http.urlpost('/Pro/SR/SRBillOrder', parm, function (res) {
                        if (res.Success == 1) {
                            that.$message({
                                duration: 0,
                                showClose: true,
                                message: that.$processdata.explainCallbackMsg(res.Msg),
                                type: 'success'
                            })
                            that.visOrder = false
                            that.getView()
                            that.getDetail(that.code)
                        } else if(res.Success > 1){
                            that.$confirm(that.$processdata.explainCallbackMsg(res.Msg), that.$t('getapi[194]'), {
                                confirmButtonText: that.$t('getapi[1146]'),
                                cancelButtonText: that.$t('getapi[2054]'),
                                type: 'warning'
                            })
                                .then(() => {
                                    that.confirmBillOrder(res.Success)
                                })
                                .catch(() => {
                                    this.$message({
                                        type: 'info',
                                        message: that.$t('getapi[6096]')
                                    });
                                });
                        }
                    });
                }
            },
            //取消
            billCancel(){
                let that = this
                let parm = {
                    sr_code: that.dataDetail.Head.sr_code,
                    sr_status: that.dataDetail.Head.sr_status,
                    modify_time: that.dataDetail.Head.modify_time
                }
                that.$http.urlpost('/Pro/SR/SRBillCancel', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message({
                            duration: 0,
                            showClose: true,
                            message: that.$processdata.explainCallbackMsg(res.Msg),
                            type: 'success'
                        })
                        that.getView()
                        that.getDetail(that.code)
                    }
                });
            },
            imp(){
                let item = {
                //label: 'SR导入',
                label: '通用导入',
                name: 'exp',
                path: '/exp/9',
                url: '/exp/9',
                icon: 'video-play'
                };
                this.$router.push({ path: '/exp/9' });
                this.$store.commit('selectMenu', item);
            },
            checkDataChange(){
                let that = this
                //如果无保存权限，直接关闭
                if(that.$limits.authority('plv3', 178,1) < 1){
                    return false
                }
                let flag =  that.oldDataDetail != JSON.stringify(that.dataDetail)
                return flag
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    /deep/ .green {
        background: #c8ffbb;
    }
    /deep/ .red {
        background: #ff7879;
    }
</style>
